import React, { useEffect } from "react";
import classNames from "classnames/bind";
import styles from "./DefaultLayout.module.scss";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import CartSidebar from "../CartSidebar/CartSidebar";
import AuthModal from "../../components/AuthModal/AuthModal";
import WishListModal from "../../components/WishListModal/WishListModal";
import CookieConsentBanner from "../../components/CookieConsentBanner/CookieConsentBanner";
import useWishlistStore from "../../stores/WishList/WishListStore";
import useCartStore from "../../stores/Cart/useCartStore";
import useFilterStore from "../../stores/Filter/useFilterStore";
import { useCategoryStore } from "../../stores/categories/useCategoryStore";
import useAuthStore from "../../stores/Auth/AuthStore";
import useConsentStore from "../../stores/Consent/useConsentStore";

const cx = classNames.bind(styles);

const DefaultLayout = ({ children }) => {
  const { ShowWishlist } = useWishlistStore();
  const { showCart } = useCartStore();
  const { setFilterData } = useFilterStore();
  const { getCategoriesApi } = useCategoryStore();
  const { checkAuthUser } = useAuthStore();
  const { hydrate: hydrateConsent } = useConsentStore();

  useEffect(() => {
    const init = async () => {
      // 1. Hydrate consent trước — quyết định storage backend cho guest data
      hydrateConsent();

      // 2. Check auth song song với các init task không phụ thuộc auth
      const [authResult] = await Promise.all([
        checkAuthUser(),
        getCategoriesApi(),
        setFilterData(),
      ]);

      const isLoggedIn = authResult?.success === true;

      // 3. Set mode cho cart/wishlist stores trước khi load data
      useCartStore.getState().setGuestMode(!isLoggedIn);
      useWishlistStore.getState().setGuestMode(!isLoggedIn);

      // 4. Load cart và wishlist theo mode đã set
      //    - Logged-in: gọi backend API
      //    - Guest: đọc từ localStorage/sessionStorage (theo consent)
      showCart();
      ShowWishlist();
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleUnauthorized = () => {
      useAuthStore.getState().markUnauthenticated();
      useCartStore.getState().setGuestMode(true);
      useWishlistStore.getState().setGuestMode(true);
    };

    window.addEventListener("lianne:auth-unauthorized", handleUnauthorized);
    return () => {
      window.removeEventListener(
        "lianne:auth-unauthorized",
        handleUnauthorized
      );
    };
  }, []);

  return (
    <div className={cx("wrapper")}>
      <Header />
      <AuthModal />
      <WishListModal />
      <div className={cx("container")}>
        <div className={cx("content")}>{children}</div>
      </div>
      <Footer />
      <CartSidebar />
      {/* Cookie Consent Banner — hiện khi status === "unknown" */}
      <CookieConsentBanner />
    </div>
  );
};

export default DefaultLayout;
